/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum ServiceAccountFeature {
    appsecops__onboarding = 'appsecops__onboarding',
    assessments__wellarchitected = 'assessments__wellarchitected',
    assessments__wellarchitected__auto_assessment = 'assessments__wellarchitected__auto_assessment',
    assessments__wellarchitected__auto_assessment__aws_sync = 'assessments__wellarchitected__auto_assessment__aws_sync',
    assessments__wellarchitected__custom_framework__aws_sync = 'assessments__wellarchitected__custom_framework__aws_sync',
    cloudops__activity = 'cloudops__activity',
    cloudops__activity__periodic = 'cloudops__activity__periodic',
    cloudops__activity__real_time_sync_read = 'cloudops__activity__real_time_sync_read',
    cloudops__activity__real_time_sync_write = 'cloudops__activity__real_time_sync_write',
    cloudops__ai_prompt_analytics = 'cloudops__ai_prompt_analytics',
    cloudops__ai_telemetry = 'cloudops__ai_telemetry',
    cloudops__backup_management = 'cloudops__backup_management',
    cloudops__cloudwatch_agent = 'cloudops__cloudwatch_agent',
    cloudops__monitoring_alerts = 'cloudops__monitoring_alerts',
    cloudops__monitoring_alerts__periodic = 'cloudops__monitoring_alerts__periodic',
    cloudops__monitoring_alerts__real_time_sync_read = 'cloudops__monitoring_alerts__real_time_sync_read',
    cloudops__monitoring_alerts__real_time_sync_write = 'cloudops__monitoring_alerts__real_time_sync_write',
    cloudops__patch_management = 'cloudops__patch_management',
    cloudops__runbooks = 'cloudops__runbooks',
    cloudops__utilization = 'cloudops__utilization',
    core__inventory = 'core__inventory',
    core__inventory__management = 'core__inventory__management',
    core__policy_engine = 'core__policy_engine',
    core__policy_engine__aws_config = 'core__policy_engine__aws_config',
    core__policy_engine__azure_policy = 'core__policy_engine__azure_policy',
    core__resource_discovery = 'core__resource_discovery',
    core__resource_discovery_extra = 'core__resource_discovery_extra',
    core__tagging_governance = 'core__tagging_governance',
    core__tagging_governance_extra = 'core__tagging_governance_extra',
    finops__assessments = 'finops__assessments',
    finops__azurehybridbenefit_recommendations = 'finops__azurehybridbenefit_recommendations',
    finops__budget = 'finops__budget',
    finops__cloud_native_recommendations = 'finops__cloud_native_recommendations',
    finops__cost_anomaly = 'finops__cost_anomaly',
    finops__cost_processing = 'finops__cost_processing',
    finops__cost_savings = 'finops__cost_savings',
    finops__enterprise_discount_program = 'finops__enterprise_discount_program',
    finops__reservation = 'finops__reservation',
    finops__right_size_recommendations = 'finops__right_size_recommendations',
    finops__savings_plans = 'finops__savings_plans',
    finops__schedule_recommendations = 'finops__schedule_recommendations',
    integration__application_performance_monitoring = 'integration__application_performance_monitoring',
    integration__azure_security_graph = 'integration__azure_security_graph',
    integration__azure_sentinel = 'integration__azure_sentinel',
    integration__tenable_nessus = 'integration__tenable_nessus',
    secops__access = 'secops__access',
    secops__aws_security_hub = 'secops__aws_security_hub',
    secops__azure_recommendations__read = 'secops__azure_recommendations__read',
    secops__cloud_native_security_information_event_management = 'secops__cloud_native_security_information_event_management',
    secops__compliance = 'secops__compliance',
    secops__threats = 'secops__threats',
    secops__threats__posture_read = 'secops__threats__posture_read',
    secops__threats__posture_write = 'secops__threats__posture_write',
    secops__threats__realtime_alerts_read = 'secops__threats__realtime_alerts_read',
    secops__threats__realtime_alerts_write = 'secops__threats__realtime_alerts_write',
    secops__vulnerabilities = 'secops__vulnerabilities',
    secops__vulnerabilities__read = 'secops__vulnerabilities__read',
    secops__vulnerabilities__write = 'secops__vulnerabilities__write',
    selfservice__governance = 'selfservice__governance',
    system__roles = 'system__roles'
}
